// The floating trial button.
//
// It is a plain link in the markup, hidden until the page has scrolled past
// the hero — the header's own CTA is still on screen before that, so showing
// both would just be the same action twice. The class goes on <html> so the
// transition is driven entirely by CSS.
const SHOW_AFTER = 320

export function setupFloatCta() {
  if (!document.querySelector("[data-float-cta]")) return

  // The scroll handler used to read scrollY and write the class on every event.
  // The write invalidated style, so the next event's read had to force layout to
  // answer — a forced reflow per scroll event, 37ms of them over a Lighthouse
  // run. Now the read happens once per frame inside rAF, and the class is only
  // written when the answer actually changes.
  let shown = null
  let queued = false

  const apply = () => {
    queued = false
    const next = (window.scrollY || document.documentElement.scrollTop) > SHOW_AFTER
    if (next === shown) return
    shown = next
    document.documentElement.classList.toggle("mca-cta-on", next)
  }

  const schedule = () => {
    if (queued) return
    queued = true
    requestAnimationFrame(apply)
  }

  window.addEventListener("scroll", schedule, { passive: true })
  window.addEventListener("resize", schedule)
  apply()
}
